import { useSyncExternalStore } from 'react';

export const desktopReducedMotionQuery = 'screen and (min-width: 901px) and (prefers-reduced-motion: reduce)';
function subscribe(onChange: () => void) {
  const media = window.matchMedia(desktopReducedMotionQuery);
  media.addEventListener('change', onChange);
  return () => media.removeEventListener('change', onChange);
}
// Inform the component lifecycle as well as CSS; do not wait for cancelled events.
export function useDesktopReducedMotion() {
  return useSyncExternalStore(subscribe, () => window.matchMedia(desktopReducedMotionQuery).matches, () => false);
}
